/**
 * @file コンポーネント：フル動画ページスレッドポップアップ一覧ページ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledButtonList = styled.ul`
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
    margin-bottom: 24px;

    ${mediaQuery.sp(`
        flex-direction: column;
        align-items: flex-end;
    `)};

    ${mediaQuery.spWide(`
        flex-direction: column;
        align-items: flex-end;
    `)};
`;

export const StyledButtonListItem = styled.li`
    margin-right: 16px;

    &:last-child {
        margin-right: 0;
    }

    ${mediaQuery.sp(`
        margin-right: 0;
        margin-bottom: 16px;

        &:last-child {
            margin-bottom: 0;
        }
    `)};

    ${mediaQuery.spWide(`
        margin-right: 0;
        margin-bottom: 16px;

        &:last-child {
            margin-bottom: 0;
        }
    `)};
`;

export const StyledContainer = styled.div`
    padding-bottom: 24px;
`;

export const StyledThreadList = styled.ul`
    margin: 24px 0;
`;

export const StyledThreadListItem = styled.li`
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }
`;
